<template>
  <div>
    <section-title :highlight="isInstructionVisible">
      <template v-if="isInstructionVisible">Click on up to 3 stocks to purchase them</template>
      <template v-else>Stocks available for purchase</template>
    </section-title>

    <div class="stocks-container">
      <div class="another-container">
        <stocks-available-card
          v-for="stock in stocksSortedByStartingPrice"
          :key="stock.id"
          :hotel="stock"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {NS_GAME_STATE} from "@/store/constants";
import SectionTitle from "@/components/SectionTitle";
import StocksAvailableCard from "@/components/board/StocksAvailableCard";

export default {
  name: "StocksAvailable",

  components: {
    StocksAvailableCard,
    SectionTitle,
  },

  data() {
    return {
      error: '',
    }
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'stocksSortedByStartingPrice',
      'isMyTurn',
      'isBuyingStocks',
    ]),

    isInstructionVisible() {
      return this.isMyTurn && this.isBuyingStocks;
    },
  },
}
</script>

<style scoped>
.stocks-container {
  max-width: 100vw;
  overflow-y: scroll;
}

.another-container {
  display: flex;
  padding: 10px;
}
</style>
